<template>
  <div>
    <mg-dialog
      :show.sync="dialogVisible"
      title=""
      size="small"
      :append-to-body="true"
      @cancel="cancel"
    >
      <div class="protocol-content">
        <div class="title">请先阅读并同意一下协议</div>
        <span class="text">
          <el-link
            :underline="false"
            :href="webUrl + '/service-agreement'"
            target="_blank"
            type="primary"
            style="margin: 0 3px"
          >
            服务协议
          </el-link>
          和
          <el-link
            :underline="false"
            :href="'https://cdn.moguocdn.com/cdn/static/privacy-policy.html'"
            target="_blank"
            type="primary"
            style="margin: 0 3px"
          >
            隐私政策
          </el-link>
        </span>
      </div>
      <div class="footer-btn">
        <el-button size="mini" @click="onClickCancel"> 我再看看 </el-button>
        <el-button type="primary" size="mini" @click="onClickConfirm"
          >同意</el-button
        >
      </div>
    </mg-dialog>
  </div>
</template>

<script>
import MgDialog from "@saas/components/src/components/mg-dialog/Index.vue";
import { uploadLiveLog } from "@saas/components/src/utils/log";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
      },
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  data() {
    return {
      dialogVisible: false,
      timer: null,
      webUrl: process.env.VUE_APP_SAAS_WEB_URL,
    };
  },
  methods: {
    onClickConfirm() {
      // 上传日志：同意协议
      uploadLiveLog({
        message: "同意协议",
        module: "login",
        level: "info",
        tag: "userAction",
        extra: {
          component: "ProtocolConfirmDialog",
        },
      }, true);
      
      this.$emit("confirm");
      this.dialogVisible = false;
    },
    onClickCancel() {
      // 上传日志：取消协议
      uploadLiveLog({
        message: "取消协议",
        module: "login",
        level: "info",
        tag: "userAction",
        extra: {
          component: "ProtocolConfirmDialog",
        },
      }, true);
      
      this.$emit("cancel");
      this.dialogVisible = false;
    },
    cancel() {},
  },
  components: {
    MgDialog,
  },
};
</script>

<style scoped lang="scss">
.protocol-content {
  text-align: center;
}
.footer-btn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  text-align: center;
}
</style>
